import Head from "next/head";

export default function Seo({ title, description, canonical }) {
  
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="real-time polling software, live polling tool, audience response system, instant polls"
      />
      <link rel="canonical" href={canonical} />
      <link rel="icon" href="/favicon.ico" />

      <meta name="robots" content="index,follow" />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Instant Polls" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Head>
  );
}